// Ameublement français (AF) member names
// Source: Liste des adhérents - l'Ameublement français.xlsx
// Auto-generated - 2026-05-13

const AF_MEMBER_NAMES = new Set([
    "100 DETOURS",
    "20 20 TECHNOLOGIES",
    "99 DECO",
    "A2P",
    "ABADIE",
    "ABAT JOUR DECO",
    "ABC MEUBLES",
    "ABC MEUBLES SARL",
    "ABEIL",
    "ACCES-SIT",
    "ACROPOSE",
    "ACTA MOBILIER",
    "ADECO INTERNATIONAL",
    "ADECO MOBILIER",
    "ADIANE SOCIETE NOUVELLE",
    "ADOVA GROUP",
    "AGSAP ATELIER DU DOUET",
    "AIRBORNE",
    "AIRBORNE DESIGN",
    "ALF FEY",
    "ALKI",
    "ALLIANCE MANUFACTURES DE FRANCE",
    "ALLURE D'AZUR",
    "ALSACE BEDDING",
    "ALSAPAN",
    "ALUMINOR",
    "AMBIANCE BAIN",
    "ANDRE RENAULT",
    "ARCHEA - UNITÉ DE PRODUCTION",
    "ARDAMEZ",
    "AREA PRODUCTION",
    "ARLITEC",
    "ARMOR PANNEAUX",
    "ART ET FLORITUDE",
    "ART ET STYLE",
    "ARTISANS DES RESEAUX",
    "ARÉA | MOBILIER URBAIN",
    "ATECH",
    "ATELIER ALAIN ELLOUZ",
    "ATELIER CATTIAUX OLIVIER CHEVRON SUCCESSEUR",
    "ATELIER CATTIAUX SUCCESSEUR",
    "ATELIER COUP D'LAQUES",
    "ATELIER D'AGENCEMENT CROUZET",
    "ATELIER DE LA BOISERIE",
    "ATELIER EMMAUS",
    "ATELIER EMMAÜS",
    "ATELIER FRANCK GENSER",
    "ATELIER HANGGI",
    "ATELIER HUGO DELAVELLE",
    "ATELIER MIDAVAINE",
    "ATELIERS FAURE",
    "ATELIERS LISON DE CAUNES",
    "ATELIERS PINTON",
    "AUBE BEDDING",
    "AUREHUM",
    "AVANCE TECHNOLOGIQUE CHOLETAISE",
    "AZUR CONFORT",
    "B & F PRODUCTIONS",
    "B MARLY",
    "BAUDRY",
    "BAXTER INTERNATIONAL",
    "BEAUTIFUL & LUXURY PARTICIPATIONS",
    "BENE",
    "BENE GMBH",
    "BERNIER FRERES",
    "BIESSE",
    "BIESSE FRANCE",
    "BIOBJECT FRANCE",
    "BLUM FRANCE",
    "BODIGUEL DAVID",
    "BOUTIQUE GRIFFON",
    "BROCATELLE",
    "BROUILLET PRODUCTION",
    "BRUT DE BOIS",
    "BURGBAD FRANCE",
    "BURONOMIC",
    "BUTON INDUSTRIES",
    "CAMBIUM",
    "CARLES FUNERAIRE",
    "CARSALADE MOBILIER",
    "CASSANO, LE CHÊNE GAULOIS",
    "CBA MEUBLES",
    "CEDAM",
    "CENTRE BEDDING",
    "CERKIS",
    "CEVINO GLASS",
    "CEVINO GLASS / GLASS VARIATIONS",
    "GLASS VARIATIONS",
    "CF2P",
    "CHAISES NICOLLE",
    "CHARLES PARIS",
    "CHARLES REMA",
    "CIDER",
    "CIDER MOBILIER",
    "CITE CONCEPT",
    "CITE CONCEPT 2.0",
    "CLEN",
    "CLEN SOLUTIONS",
    "COFEL INDUSTRIES",
    "COLLECTION PIERRE COUNOT-BLANDIN",
    "COLLINET",
    "COMEC",
    "CONCEPT URBAIN",
    "CONCILIO",
    "COSENTINO",
    "COSENTINO SURFACES FRANCE",
    "COULIDOOR",
    "CREABOIS",
    "CREATIONS MOURRA",
    "CROUZET AGENCEMENT",
    "CUCHOT",
    "CUISINES DESIGN INDUSTRIES",
    "CUISINES MOREL SN",
    "CVL LUMINAIRES",
    "CYRIA",
    "D'ARGENTAT",
    "DAGARD",
    "DAILLOT INTERNATIONAL",
    "DAVILAINE",
    "DC 1840",
    "DECOTEC",
    "DELAVELLE",
    "DENANTES",
    "DENIS INDUSTRIES",
    "DESIGN CONCEPT",
    "DIROY",
    "DISCAC",
    "DISCAC IMMO",
    "DISSIDI",
    "DIZY",
    "DIZY SAS",
    "DRUGEOT (LES ATELIERS DU)",
    "DRUGEOT MANUFACTURE",
    "DUMONT ET CIE - EMDE",
    "DUVIVIER CANAPÉS",
    "EBAC LITERIE",
    "EBENISTERIE PIERRE JOUSSOT ET FILS",
    "ECHEVARRIA-SIEGES DE STYLE (ETABLISSEMENT)",
    "EG EBENISTERIE GENERALE",
    "EGGER PANNEAUX ET DECORS",
    "EGO",
    "EGO PARIS",
    "EMDE",
    "ESPACE LOGGIA",
    "ETABLISSEMENTS CHABOT",
    "ETABLISSEMENTS DAVILAINE",
    "ETABLISSEMENTS JEAN MARIE BRUNIAUX",
    "ETABLISSEMENTS SOGAL",
    "ETAT DE SIEGES",
    "ETS CANARD",
    "EURO AUTOMATION",
    "EUROSIT",
    "EVERSTYL",
    "EXPERTS DU MONTAGE",
    "EXTRAMUROS SAS",
    "FABRIQUE DE MEUBLES DE COULOMBS",
    "FERMOB",
    "FOURMENT CHRISTIAN ET FILS",
    "FOURNIER",
    "FOURNIER SAS",
    "FR BEDDING",
    "FRANCK GENSER",
    "FURNITURE FOR GOOD",
    "GABRIEL AS",
    "GAUDIN PASCAL",
    "GAUDIN RENE",
    "GAUTIER FRANCE",
    "GCC",
    "GENEXCO",
    "GESTAS CREATIONS",
    "GOURLIER",
    "GROSFILLEX",
    "GROUPE COFEL",
    "GROUPE ELEMEN",
    "GUYON",
    "GÉRALD CATTIN",
    "HARTO - ORIZON",
    "HAWORTH",
    "HEGAPOLE",
    "HELLIN",
    "HENRY SAS",
    "HENRY SAS - FABRICANT FRANÇAIS DE MOBILIER URBAIN & PRODUITS SUR-MESURE",
    "HERMAN MILLER",
    "HERVE CAILL",
    "HESTIA CONCEPT",
    "HETTICH",
    "HETTICH FRANCE",
    "HILL ROM",
    "HOME SPIRIT",
    "HOTELYS",
    "HOUSSARD MOBILIER",
    "HOYEZ SAS",
    "HUBERT BRAYE",
    "HUSSON INTERNATIONAL",
    "IMAGE",
    "IMAGE - ISAAC MOBILIER AGENCEMENT EDITION",
    "IN-IPSO",
    "INGENIA",
    "INTEGRALE D'AGENCEMENT",
    "INTERPLUME",
    "ISOPLAST",
    "JACQUART ET FILS SAS",
    "JEAN MARIE BRUNIAUX",
    "JEAN PIERRE BESSE MANUFACTURE DE SIEGES",
    "JEUDI FACTORY",
    "JH INDUSTRIES",
    "KAZED",
    "KINNARPS",
    "KOENIG FACTEURS D'ORGUES",
    "KOHLER FRANCE",
    "KOHLER FRANCE - SANIJURA",
    "L'ATELIER EXTRAMUROS",
    "LA CHAISE FRANCAISE",
    "LA CHAISE FRANÇAISE",
    "LA CHANCE",
    "LA FABRIQUE",
    "LAFA COLLECTIVITES",
    "LAFUMA MOBILIER",
    "LAUDESCHER SAS",
    "LAUGERE TRADITIONS",
    "LAURENT PLET",
    "LAVAL COLLECTION",
    "LE BOIS DE DEUX MAINS",
    "LE CREATEUR DU SIEGE",
    "LE SOMMEIL FRANCAIS",
    "LEMAR GROUPE",
    "LES ATELIERS DU DOUET",
    "LES MENUISERIES ARIEGEOISES",
    "LES MENUISERIES DU CENTRE",
    "LESTRA",
    "LIDO PARIS",
    "LIGNE ROSET",
    "LINAK FRANCE",
    "LINEX PANNEAUX",
    "LITERIE BONNET",
    "LMC",
    "LVMC",
    "MAGNANI AGENCEMENT",
    "MAISON DRUCKER",
    "MAISON FEY",
    "MAISON GATTI",
    "MAISON JEUDI",
    "MAISON POUENAT",
    "MAISON SARAH LAVOINE",
    "MAKIBA",
    "MALBREL CONSERVATION",
    "MALVAUX INTERIOR",
    "MALVAUX MANUFACTURES",
    "MALVAUX ORIGIN",
    "MANUFACTURE D'ORGUES ET CLAVECIN",
    "MANUFACTURE D'ORGUES QUENTIN REQUIER",
    "MANUFACTURE D’ORGUES MUHLEISEN",
    "MANUFACTURE EUROPEENNE DE LITERIE PYRENEX",
    "MANUFACTURE LANGUEDOCIENNE DE GRANDES ORGUES",
    "MANUFACTURE ORGUES GUERRIER",
    "MANUFACTURE ORGUES GUERRIER ASSOCIES",
    "MANUFACTURE QUENTIN BLUMENROEDER",
    "MANUFACTURE QUENTIN BLUMENROEDER SAS",
    "MANUFACTURE ROBERT FOUR",
    "MARCHAND",
    "MARCHAND SOLUTIONS",
    "MARGAUX KELLER COLLECTIONS",
    "MATELOO",
    "MATERIC",
    "MATERIC LUNDIA",
    "MATIERE GRISE",
    "MATIERE GRISE INDUSTRIE",
    "MATTRESS FRANCE",
    "MDC",
    "MEUBLES AUGER",
    "MEUBLES CELIO",
    "MEUBLES GENTE",
    "MEUBLES RINCK",
    "RINCK",
    "MEUBLES THOURET",
    "MICHEL JURINE FACTEUR D'ORGUES",
    "MILLERKNOLL",
    "MINET",
    "MIROITERIE PETITJEAN",
    "MK COLLECTIONS",
    "MOBEXTAN",
    "MOBIL CONCEPTS",
    "MOISSONNIER",
    "MONSIEUR JEAN GAUPILLAT",
    "MOUSSE DU NORD MATNOR",
    "MSA FRANCE",
    "MUHLEISEN G WALTHER ET ASSOCIES (MANUFACTURE D’ORGUES)",
    "MYO",
    "NATION LITERIE",
    "NATION LITERIE SARL",
    "NATUREN",
    "NOMA EDITIONS",
    "NORD BEDDING",
    "NORKI",
    "NOWYSTYL FRANCE",
    "OBJEKTO",
    "OGER ET FILS",
    "OGF",
    "OPTIMUM",
    "ORGUES GIROUD",
    "ORGUES GIROUD SUCCESSEURS",
    "ORIZON",
    "ORSINI",
    "OUEST BEDDING",
    "OUEST PLACARD",
    "P3G GROUP SAS",
    "PANNEAUX DE CORREZE",
    "PAPIN INDUSTRIE",
    "PARISOT INDUSTRIE",
    "PASCAL FACTEURS D'ORGUES",
    "PASCAL QUOIRIN",
    "PELLERIN ET UYS",
    "PESCE FRERES ET FILS",
    "PFLEIDERER",
    "PHILIPPE HUREL",
    "PIERRE LAVAL",
    "PLACARDSTYL",
    "PLAS ECO",
    "PLASECO",
    "PORTEA",
    "POST INDUSTRIAL CRAFTS",
    "PRO URBA",
    "PRO URBA HOLDING",
    "PROSTYL",
    "PYRAM",
    "PYRAM INDUSTRIES",
    "PYRENEX",
    "QUENTIN REQUIER",
    "QUOIRIN (ORGUE)",
    "RED EDITION",
    "REHAU",
    "REHAU SA",
    "REKTO",
    "REMA YOU EVOLUTION",
    "REMA YOU EXPANSION",
    "RENE BIDET",
    "RENE HENRY",
    "RESISTUB PRODUCTIONS",
    "REVISIT",
    "RICHARD MOBILIER",
    "RM MOBILIER",
    "ROBERT FOUR",
    "ROBERT FRERES MANUFACTURE D'ORGUES",
    "RODET",
    "RONDINO",
    "ROSET SAS",
    "SA LES CREATIONS DU VAL DE LOIRE",
    "SACMA FURANIA",
    "SAGA AGENCEMENT",
    "SAGA AGENCEMENT (GROUPE HASAP)",
    "SARAH LAVOINE SAS",
    "SARL ABAT JOUR DECO",
    "SARL FRANCK AUGER",
    "SARL LAUGERE TRADITIONS",
    "SARL PESCE FRERES ET FILS",
    "SAS 99 DECO",
    "SAS ALUMINOR",
    "SAS ATELIERS FAURE",
    "SAS ATELIERS PINTON",
    "SAS KAZED",
    "SAS RENE HENRY",
    "SAUTHON INDUSTRIES",
    "SAÔNOISE",
    "SCA THIRIEZ LITERIE",
    "SCHMIDT GROUPE",
    "SCIAE DIENVILLE",
    "SEDUS",
    "SEED",
    "SEED GAMMISTE",
    "SELLERIE DU PILAT",
    "SEMCO",
    "SEVE MOBILIER",
    "SIBO",
    "SIEGEAIR",
    "SIGEBENE",
    "SIGNALISATION PROTECTION LOGISTIQUE",
    "SIMEA",
    "SIMMOB",
    "SIMMOB - BUROCEAN",
    "SIMMONS",
    "SNCEP",
    "SOCA SELLIERS",
    "SOCIETE ARDECHOISE DU MATELAS METALLIQUE",
    "SODEMATUB NAUDIN",
    "SOFART",
    "SOGAL DIRECTIONS SUPPORTS",
    "SOKOA",
    "SOMEPAN",
    "SOTOMOB",
    "SOUCHET",
    "SOUCHET INSPIRED WOODWORK",
    "SOURICE",
    "SPL - PROCITY",
    "SQUARE SOLUTIONS PARIS",
    "STAMP",
    "STAMP EDITION",
    "STRATOBOIS",
    "STYLE ET CONFORT",
    "SYNDICAT FRANCAIS DE LA LITERIE",
    "T MOBILIER",
    "TAILLARDAT",
    "TANGUY ET CIE (ETABLISSEMENTS)",
    "THIRIEZ LITERIE",
    "THOONSEN",
    "THOONSEN TRADING",
    "THOURET OLIVIER",
    "TISSAGES DENANTES",
    "TISSERANT",
    "TOLERIE FOREZIENNE",
    "TOLIX",
    "TOLIX STEEL DESIGN",
    "TOQUARD",
    "TORBEL INDUSTRIE",
    "TRIMAT",
    "TUYAUX D’ORGUES",
    "ULMANN",
    "UNILIN",
    "UNIVERS ET CITE",
    "VARIATION",
    "VAZARD AMEUBLEMENT",
    "VICTOR MANGEOL FACTEUR D'ORGUES",
    "WE BED",
    "WEBER INDUSTRIES",
    "WM88",
    "WUEKO",
    "YOU",
    "YOU INDUSTRIE",
]);

export default AF_MEMBER_NAMES;
